import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
import { ApiService } from '../shared/services/api.service';
import { UserService } from '../shared/services/user.service';
import { CommonService } from '../shared/services/common.service';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.page.html',
  styleUrls: ['./splash.page.scss'],
})
export class SplashPage implements OnInit {
  isnative: any;
  constructor(
    private userService: UserService, 
    private platform: Platform,
    private navController: NavController,
    private commonService: CommonService
  ) {


  }

  ngOnInit() {
    this.platform.ready().then(() => {

      this.commonService.canUseNative().then((res:any) => {
        this.isnative = res;
        if(res) {
          this.checkIntroSteps();
        } else {
          // this.checkIntroSteps();
          this.checkValidUser();
        }
      }).catch(e => {
        this.checkValidUser();
      });
    }).catch(e => {
      this.checkIntroSteps();
      // this.checkValidUser();
    });
  }

  checkIntroSteps(){

    this.userService.getIntroSteps().then((res: any) => {
      if(res) {
        this.checkValidUser();
      } else {
        //Navigate to intro screens
        this.navController.navigateRoot('/welcome');
      }
    }).catch(e => {
      this.navController.navigateRoot('/welcome');
    });
  }

  checkValidUser(){
    //Check if the user is valid or navigate the user back to login page
    this.userService.isValidUser().then((isvalid: boolean) => {
      //user is valid. send to signup page
      this.navController.navigateRoot('/dashboard');
    }).catch(e => {
      console.log(e);
      //User not valid. send to login page
      this.navController.navigateRoot('/login');
    });
  }

}
